<template>
  <v-container fluid grid-list-xl>
    <v-layout row fill-height>
      <v-flex xs8 offset-xs2>
        <v-btn small to="/freeSamples">Back to Free Samples</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row v-if="order">
      <v-flex xs8 offset-xs2>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-card>
              <v-card-title><h4>Customer Details</h4></v-card-title>
              <v-divider></v-divider>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>Order Code:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ order.orderCode }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Name:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ order.customerID.firstName }} {{ order.customerID.lastName }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Phone:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ order.customerID.phone }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Email:</v-list-tile-content>
                  <v-list-tile-content class="align-end"><a :href="`mailto:${order.customerID.email}`">{{ order.customerID.email }}</a></v-list-tile-content>
                </v-list-tile>
                <template v-if="order.customerID.address">
                  <v-list-tile>
                    <v-list-tile-content>Address:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ order.customerID.address.address }}<br>{{ order.customerID.address.city }}, {{ order.customerID.address.state }} {{ order.customerID.address.postcode }}</v-list-tile-content>
                  </v-list-tile>
                </template>
                <template v-else>
                  <v-list-tile>
                    <v-list-tile-content style="color: red; font-weight: bold;">Address not found.</v-list-tile-content>
                  </v-list-tile>
                </template>
                <v-list-tile v-if="order.deliveryInstructions">
                  <v-list-tile-content>Order Instructions:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ order.orderInstructions }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="order.deliveryInstructions">
                  <v-list-tile-content>Delivery Instructions:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ order.deliveryInstructions }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex> <!-- Details -->
          <v-flex xs12 md6>
            <v-card v-if="order">
              <v-card-title><h4>Actions</h4></v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-text-field label="Provide Australia Post Tracking Reference" v-model="order.trackingReference"></v-text-field>
                <v-divider></v-divider>
                <v-checkbox label="Email Customer Tracking Update" color="primary" v-model="sendEmail"></v-checkbox>
                <v-btn color="primary" @click="markOrderAsSent()">Mark as Sent to Customer and Return</v-btn>
              </v-card-text>
            </v-card>
          </v-flex> <!-- Actions -->
          <v-flex xs12 md6>
            <v-card v-if="order">
              <v-card-title><h4>Samples</h4></v-card-title>
              <v-divider></v-divider>
              <v-list dense>
                <div v-for="(samples, index) in newFreeSamples" :key="index">
                  <v-list-tile v-if="samples.length > 0">
                    <v-list-tile-content><strong>{{index.replace(/_/g, ' ')}}</strong></v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-for="(sample, index2) in samples" :key="index2">
                    <v-list-tile-content>{{ sample.fabricID.name }} {{ sample.colourID.name }}</v-list-tile-content>
                  </v-list-tile>
                </div>
              </v-list>
            </v-card>
          </v-flex> <!-- Samples -->
          <!-- <v-flex xs12 md6>
            <v-card>
              <v-card-title>
                <h4>New Task</h4>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-select v-model="task.type" label="Type" :items="[
                  { text: 'Follow up Customer' },
                  { text: 'Call Customer on Future Date' },
                  { text: 'Follow up After Sending Free Samples' },
                  { text: 'Customer has been Quoted' },
                  { text: 'Follow up Quote' },
                  { text: 'Follow up Payment' },
                  { text: 'Note' },
                ]"></v-select>
                <v-textarea label="Remarks" v-model="task.remark"></v-textarea>
                <v-date-picker v-model="task.dueDate" :landscape="true"></v-date-picker>
                <p>Assigned: Me</p>
                <v-checkbox label="Done?" v-model="task.done"></v-checkbox>
                <v-btn color="primary" @click="createTask()">Add Task</v-btn>
              </v-card-text>
            </v-card>
          </v-flex> --> <!-- New Task -->
          <!-- <v-flex xs12>
            <v-card>
              <v-card-title>
                <h4>Tasks</h4>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-list dense>
                  <v-list-tile v-for="(task, index) in tasks" :key="index">
                    <v-list-tile-content>{{ task.type }} - {{ task.remark }} (Due: {{ new Date(task.dueDate).getDate() }}/{{ new Date(task.dueDate).getMonth() + 1 }}/{{ new Date(task.dueDate).getFullYear() }})</v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-text>
            </v-card>
          </v-flex> --> <!-- Tasks -->
          <v-flex xs12 md6>
            <v-card>
              <v-card-title>
                <h4>Order History</h4>
              </v-card-title>
              <v-divider></v-divider>
              <table width="80%" class="tableHistory text-xs-center pa-3" v-if="showOrderHistory">
                <tr>
                  <th class="text-xs-left">Order Code</th>
                  <th>Date</th>
                  <th>No. of Samples</th>
                </tr>
                <tr v-for="(order, index) in orderHistory" :key="index">
                  <td class="text-xs-left"><v-btn small flat color="primary" @click="$router.push({ path: `/freeSampleOrder/${order.id}` }),newFreeSamples=[], getOrder()">{{order.orderCode}}</v-btn></td>
                  <td>{{order.date}}</td>
                  <td>{{order.freeSamples}}</td>
                </tr>
              </table>
              <v-flex xs8 text-xs-center m0a v-if="showOrderHistory === false">
                <v-progress-circular
                indeterminate
                color="primary">
                </v-progress-circular>
              </v-flex>
            </v-card>
          </v-flex>  <!-- Order History -->
        </v-layout>
      </v-flex>
    </v-layout>

    <v-snackbar dark top v-model="snackbar" :timeout="3000">
      {{ popupText }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import FreeSampleService from '@/services/FreeSampleService'
import OrderService from '@/services/OrderService'
// import TaskService from '@/services/TaskService'
import moment from 'moment'
export default {
  data () {
    return {
      order: null,
      sendEmail: true,
      trackingReference: null,
      task: {
        orderID: null,
        type: null,
        remark: null,
        dueDate: null,
        assigned: null,
        done: false
      },
      tasks: null,
      snackbar: false,
      popupText: null,
      showOrderHistory: false,
      orderHistory: [],
      newFreeSamples: []
    }
  },
  mounted () {
    this.getOrder()
  },
  methods: {
    async getOrder () {
      const response = await FreeSampleService.getFreeSampleOrder(this.$route.params.id)
      console.log(this.order)
      this.order = response.data.order

      // first sort by colourname
      response.data.order.freeSamples.sort(function (a, b) {
        var nameA = a.colourID.name.toLowerCase()
        var nameB = b.colourID.name.toLowerCase()
        if (nameA < nameB) { // sort string ascending
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        return 0
      })

      // second sort by fabric name
      response.data.order.freeSamples.sort(function (a, b) {
        var nameA = a.fabricID.name.toLowerCase()
        var nameB = b.fabricID.name.toLowerCase()
        if (nameA < nameB) { // sort string ascending
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        return 0
      })
      // console.log(response.data.order.freeSamples)
      var newFreeSamples = []
      response.data.order.freeSamples.forEach(element => {
        // console.log(element.fabricID.group.type)
        element.type = element.fabricID.group.type
        if (!Array.isArray(newFreeSamples[element.type])) {
          newFreeSamples[element.type] = []
        }
        newFreeSamples[element.type].push(element)
      })
      this.newFreeSamples = this.sortObject(newFreeSamples)
      // console.log(this.newFreeSamples)
      this.task.orderID = this.order._id
      // this.getTasks()
      this.getSampleOrderHistory()
    },
    sortObject (obj) {
      return Object.keys(obj).sort().reduce(function (result, key) {
        result[key] = obj[key]
        return result
      }, {})
    },
    async markOrderAsSent () {
      this.order.status = 'Sent to Customer'
      const response = await OrderService.updateOrder(this.order)
      if (response.data.success && this.sendEmail) {
        // old one commented
        // const emailResponse = await OrderService.emailTrackingUpdate(this.order._id)
        // new from sendGrid
        const emailResponse = await OrderService.emailFreeSampleInTransit(this.order._id)
        if (emailResponse.data.success) {
          this.$router.push({ path: `/freeSamples` })
        }
      } else if (response.data.success && !this.sendEmail) {
        this.$router.push({ path: `/freeSamples` })
      }
    },

    /* async createTask () {
      const response = await TaskService.createTask(this.task)
      console.log(response)
      if (response.data.success) {
        this.snackbar = true
        this.popupText = 'Task created successfully'
        this.getTasks()
      }
    },

    async getTasks () {
      // console.log(this.order)
      const response = await TaskService.getTasksOfOrder(this.order._id)
      if (response.data.tasks) {
        this.tasks = response.data.tasks
      }
    } */
    async getSampleOrderHistory () {
      var customerID = this.order.customerID._id
      const response = await FreeSampleService.getSampleOrderHistory(customerID)
      var orderHistory = response.data.freeSamples
      this.orderHistory = []
      for (let index = 0; index < orderHistory.length; index++) {
        const order = orderHistory[index]
        if (order._id !== this.order._id) {
          this.orderHistory.push({id: order._id, orderCode: order.orderCode, freeSamples: order.freeSamples.length, date: moment(order.date).format('DD/MM/YY')})
        }
      }
      this.showOrderHistory = true
    }

  }
}
</script>
<style scoped>
.tableHistory td {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/freeSamples/FreeSampleOrder.vue